"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdFlagData = exports.AdFlagData_AdFlaggedReason = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
var AdFlagData_AdFlaggedReason;
(function (AdFlagData_AdFlaggedReason) {
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["UNKNOWN_AD_FLAG_REASON"] = 0] = "UNKNOWN_AD_FLAG_REASON";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["FREQUENCY_CAP_TOO_HIGH"] = 1] = "FREQUENCY_CAP_TOO_HIGH";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["FREQUENCY_AD_LOAD"] = 2] = "FREQUENCY_AD_LOAD";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["OFFENSIVE_SEXUAL"] = 3] = "OFFENSIVE_SEXUAL";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["OFFENSIVE_VIOLENT"] = 4] = "OFFENSIVE_VIOLENT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["OFFENSIVE_SPEECH"] = 5] = "OFFENSIVE_SPEECH";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["OFFENSIVE_COPYRIGHT"] = 6] = "OFFENSIVE_COPYRIGHT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["OFFENSIVE_OTHER"] = 7] = "OFFENSIVE_OTHER";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IRRELEVANT_DEMO"] = 8] = "IRRELEVANT_DEMO";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IRRELEVANT_CONTEXT"] = 9] = "IRRELEVANT_CONTEXT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IRRELEVANT_ANNOYING"] = 10] = "IRRELEVANT_ANNOYING";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IRRELEVANT_PRODUCT"] = 11] = "IRRELEVANT_PRODUCT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IRRELEVANT_OTHER"] = 12] = "IRRELEVANT_OTHER";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["FRAUD_SCAM"] = 13] = "FRAUD_SCAM";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IP_COPYRIGHT"] = 14] = "IP_COPYRIGHT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IP_TRADEMARK"] = 15] = "IP_TRADEMARK";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["IP_PUBLICITY"] = 16] = "IP_PUBLICITY";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["RELEVANT_FTW"] = 17] = "RELEVANT_FTW";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["RELEVANT_PRODUCT"] = 18] = "RELEVANT_PRODUCT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["RELEVANT_OTHER"] = 19] = "RELEVANT_OTHER";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["ILLEGAL_CONTENT"] = 20] = "ILLEGAL_CONTENT";
    AdFlagData_AdFlaggedReason[AdFlagData_AdFlaggedReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AdFlagData_AdFlaggedReason = exports.AdFlagData_AdFlaggedReason || (exports.AdFlagData_AdFlaggedReason = {}));
function createBaseAdFlagData() {
    return { adFlagged: undefined, adFlaggedReason: 0, adFlaggedNote: undefined };
}
exports.AdFlagData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adFlagged !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.adFlagged }, writer.uint32(10).fork()).ldelim();
        }
        if (message.adFlaggedReason !== 0) {
            writer.uint32(16).int32(message.adFlaggedReason);
        }
        if (message.adFlaggedNote !== undefined) {
            wrappers_1.StringValue.encode({ value: message.adFlaggedNote }, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdFlagData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adFlagged = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.adFlaggedReason = reader.int32();
                    break;
                case 3:
                    message.adFlaggedNote = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdFlagData();
        message.adFlagged = object.adFlagged ?? undefined;
        message.adFlaggedReason = object.adFlaggedReason ?? 0;
        message.adFlaggedNote = object.adFlaggedNote ?? undefined;
        return message;
    },
};
//# sourceMappingURL=ad_flag_data.js.map